import React, { useEffect, useState } from "react";
import TabComp from "src/components/shared/TabComp";
import TableComp from "src/components/shared/table/TableComp";
import { CHECK_ORDER_DELIVERY_ALL, COMMOM_STATUS, DELIVERY_ALL_TAB } from "src/constant";
import useDABody from "../utils/delivery-all/useDABody";
import { Grid, Stack } from "@mui/material";
import useWareHouseList from "src/hooks/warehouse/useWareHouseList";
import useAuthGlobal from "src/context/useAuthGlobal";
import useQueryParams from "src/hooks/useQueryParams";
import DAPrint from "./DAPrint";
import OrderFilter from "../components/OrderFilter";
const tabs = [{ id: CHECK_ORDER_DELIVERY_ALL.deliverryAll, name: "Tạo phiếu" }];

const status = "none";
export default function DeliveryAllPage({ mutate }) {
  const [option, setOption] = useQueryParams();
  const { userMe } = useAuthGlobal();
  const [warehouseId, setWarehouseId] = useState();
  const [transportation, setTransportation] = useState(status);
  const [total, setTotal] = useState([]);
  const [paramsQuery, setParamsQuery] = useState();
  const { header, bodyList, sortData } = useDABody({
    setTotal,
    total,
    userMeWHouse: userMe?.currentWarehouse?._id,
    paramsQuery,
  });

  const { data: warehouse, isLoading: warehouseLoading } = useWareHouseList({
    limit: 50,
    skip: 0,
    shippingProvider: transportation === COMMOM_STATUS.none ? undefined : transportation,
  });

  useEffect(() => {
    if (!userMe?.currentWarehouse?._id) {
      if (!warehouseLoading) {
        if (!!warehouse?.data?.length) {
          setOption({ ...option, whouseId: warehouse?.data[0]?._id });
          setWarehouseId(warehouse?.data[0]?._id);
          setParamsQuery((prev) => ({ ...prev, warehouse: warehouse?.data[0]?._id }));
        }
      }
    } else {
      setWarehouseId(userMe?.currentWarehouse?._id);
    }
  }, [warehouse?.data, warehouseLoading, userMe?.currentWarehouse?._id]);

  return (
    <>
      <Stack
        gap={1}
        alignItems="flex-end"
      >
        <OrderFilter
          variant="delivery-all"
          setParamsQuery={setParamsQuery}
          paramsQuery={paramsQuery}
        />
        <TabComp tabs={tabs} />
      </Stack>

      {option?.child === DELIVERY_ALL_TAB.createOrderBill && (
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={9}
          >
            <TableComp
              headers={header}
              bodyList={bodyList}
              sortData={sortData}
            />
          </Grid>
          <Grid
            item
            xs={3}
          >
            <DAPrint
              total={total}
              warehouseId={warehouseId}
              setTotal={setTotal}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
